import angular from 'angular';
import uiRouter from 'angular-ui-router';
import fleetsComponent from './fleets.component';
import dataTable from 'angular-material-data-table';

const fleetsModule = angular
  .module('fleets', [uiRouter, dataTable])

  .config([
    '$stateProvider',
    $stateProvider => {
      $stateProvider.state('fleets', {
        url: '/fleets',
        component: 'fleets',
        parent: 'main',
        data: {
          permissions: {
            only: ['ADMIN'],
            redirectTo: 'home'
          }
        },
        resolve: {}
      });
    }
  ])
  .component('fleets', fleetsComponent).name;

export default fleetsModule;
